export default __webpack_public_path__ + "static/media/delinspiron.37f81777d8e6817c7cb43967deb57e69.png";